import { Profile } from "../types/quiz";
import { images } from "./images";

export const profiles: Profile[] = [
  {
    key: "nocturna",
    name: "Cena Saludable, Pero Mal Adaptada a la Noche",
    shortName: "Cena mal adaptada a la noche",
    result:
      "Tus respuestas muestran que muchas veces elegís cenas que parecen sanas, pero que pueden no ser las más adecuadas para tu digestión nocturna.",
    listTitle: "Esto suele pasar cuando la cena incluye",
    list: [
      "Verduras crudas",
      "Platos fríos",
      "Yogur o fruta",
      "Pan integral",
      "Comidas improvisadas",
      "Cenas demasiado pobres",
    ],
    sectionTitle: "Qué podría estar pasando",
    sectionText:
      "Tu cuerpo puede estar recibiendo alimentos “correctos” en apariencia, pero difíciles de procesar justo cuando debería bajar revoluciones y prepararse para reparar.",
    keyPhrase: "Tu problema no parece ser falta de voluntad. Parece ser falta de estrategia nocturna.",
    image: images.plates,
  },
  {
    key: "fermentacion",
    name: "Fermentación Nocturna y Abdomen Tenso",
    shortName: "Fermentación nocturna",
    result:
      "Tus respuestas indican una tendencia a gases, distensión o abdomen duro después de cenar o al despertar. Esto puede aparecer cuando ciertos alimentos llegan al intestino sin procesarse del todo, fermentan y generan presión abdominal.",
    listTitle: "Señales frecuentes en este perfil",
    list: ["Gases o eructos", "Panza dura", "Hinchazón después de comer", "Molestia nocturna", "Digestión lenta"],
    sectionTitle: "Qué podría ayudarte",
    sectionText:
      "Cenas más cocidas, calientes, simples y con combinaciones pensadas para reducir la carga digestiva nocturna.",
    keyPhrase: "No es tu culpa: es una señal de que tu cena necesita otra estructura.",
    image: images.mirror,
  },
  {
    key: "lenta",
    name: "Digestión Lenta Después de Comer",
    shortName: "Digestión lenta",
    result:
      "Tus respuestas muestran señales de que tu cuerpo puede tardar más de lo normal en procesar la cena.",
    listTitle: "Puede notarse como",
    list: [
      "Llenarte rápido",
      "Pesadez con poca comida",
      "Acidez",
      "Sueño incómodo",
      "Abdomen inflamado por horas",
    ],
    sectionTitle: "Qué podría estar pasando",
    sectionText:
      "Cuando la digestión va lenta, incluso una comida pequeña puede sentirse pesada si está mal combinada o llega en un momento de estrés.",
    keyPhrase: "No necesitás comer menos. Necesitás que la cena sea más fácil de procesar.",
    image: images.dinner,
  },
  {
    key: "estres",
    name: "Cena Bajo Estrés / Cortisol Nocturno",
    shortName: "Cena bajo estrés",
    result:
      "Tus respuestas muestran que muchas veces llegás a cenar acelerada, ansiosa o agotada. Cuando el cuerpo está en modo alerta, la digestión queda en segundo plano, y una cena normal puede sentirse más pesada de lo esperado.",
    listTitle: "Señales frecuentes",
    list: [
      "Cenar apurada",
      "Ansiedad por dulce",
      "Despertares nocturnos",
      "Cansancio al despertar",
      "Sensación de no descansar",
    ],
    sectionTitle: "Qué podría ayudarte",
    sectionText:
      "Un ritual de cena más simple, caliente y repetible, que no te obligue a decidir demasiado ni a cocinar durante una hora.",
    keyPhrase: "Tu cuerpo no necesita más exigencia. Necesita una señal de calma a la noche.",
    image: images.hero,
  },
  {
    key: "motilidad",
    name: "Motilidad Baja / Intestino Lento",
    shortName: "Intestino lento",
    result:
      "Tus respuestas sugieren que la constipación, la baja hidratación o la falta de movimiento pueden estar influyendo en tu hinchazón. Cuando el tránsito intestinal está lento, la fermentación aumenta y el abdomen puede sentirse más inflamado, especialmente por la noche.",
    listTitle: "Qué mirar",
    list: [
      "Agua real durante el día",
      "Movimiento diario",
      "Fibra tolerable",
      "Cenas más simples",
      "Evitar combinaciones pesadas antes de dormir",
    ],
    sectionTitle: "Qué podría ayudarte",
    sectionText:
      "Hidratación, movimiento y una cena simple forman la base de un tránsito más ordenado. La cena es la pieza que más fácil podés cambiar hoy.",
    image: images.dinner,
  },
  {
    key: "sensibilidad",
    name: "Sensibilidad Alimentaria Oculta",
    shortName: "Sensibilidad alimentaria",
    result:
      "Tus respuestas muestran que ciertos alimentos “saludables” podrían estar generándote más molestias de lo que pensás.",
    listTitle: "Puede pasar con",
    list: [
      "Lácteos y yogur",
      "Pan o trigo",
      "Legumbres",
      "Verduras crudas",
      "Ciertos carbohidratos fermentables",
    ],
    sectionTitle: "Qué significa",
    sectionText:
      "No quiere decir que esos alimentos sean “malos”. Significa que quizás tu cuerpo no los tolera igual, especialmente por la noche.",
    keyPhrase:
      "Necesitás un plan de cenas que reduzca variables, simplifique combinaciones y te ayude a observar qué te cae bien.",
    image: images.plates,
  },
];
